import { MonitorFiltersState } from './state';
import {
  MonitorFiltersActionUnion,
  MonitorFiltersActionTypes
} from './actions';

export interface FollowFilters {
  userId: string;
  followedIDs: string[];
}
export const initialMonitorFilterState: MonitorFiltersState = {};

export function monitorFiltersReducer(
  state: MonitorFiltersState = initialMonitorFilterState,
  action: MonitorFiltersActionUnion
): MonitorFiltersState {
  let newState;
  switch (action.type) {
    case MonitorFiltersActionTypes.Set:
      // eslint-disable-next-line no-case-declarations
      const { name, value } = action.payload;
      newState = {
        ...state,
        [name]: value
      };
      break;
    case MonitorFiltersActionTypes.Reset:
      if (Boolean(action.payload) && !action.payload.value) {
        newState = { ...state };
        delete newState[action.payload.name];
      } else {
        newState = initialMonitorFilterState;
      }
      break;
    default:
      return state;
  }
  return newState;
}
